/* eslint-disable react/no-danger */
import React, { Component, Fragment } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import PropTypes from 'prop-types';
import scrollToComponent from 'react-scroll-to-component-ssr';
import { JsonLd } from 'react-schemaorg';
import map from 'lodash/map';
import get from 'lodash/get';
import findIndex from 'lodash/findIndex';
import each from 'lodash/each';
import toNumber from 'lodash/toNumber';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import Bem from 'bemHelper';
import numDesc from 'helpers/numDesc';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import formatDate, { getOnlyMonthAndYear } from 'helpers/formatDate';
import DataProvider from 'api/data-provider';
import Counter from 'subsys/counter';
import Complaint from 'subsys/complaint';
import { FavoritesButton, FavoriteWrapper } from 'subsys/favorites';
import sensor from 'components/sensor';
// import InteractiveComponent from 'components/interactive-fly-component';
import Link from 'components/link';
import AdSense from 'components/adsense';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';
// import Button from 'components/button';
// import CollapseLines from 'components/clamp-lines';
import Image, { Thumb, OpenGraphImage } from 'components/image';
import Slick from 'components/slick-slider';
import TabJSControl from 'components/tab-js-control';
import YoutubeIframe from 'components/youtube-iframe';

import { getImages } from 'src-sites/domik/section-project/get-images';
// import linksBild from 'src-sites/bild/links';
// import { reliabilityIndex } from 'src-sites/bild/section-project/reliability-index';
import imgShieldGray from 'src-sites/bildcontrol/section-project/assets/shieldGray.png';
import imgShieldRed from 'src-sites/bildcontrol/section-project/assets/shieldRed.png';
import imgShieldYellow from 'src-sites/bildcontrol/section-project/assets/shieldYellow.png';
import imgShieldGreen from 'src-sites/bildcontrol/section-project/assets/shieldGreen.png';
import imgShieldBlue from 'src-sites/bildcontrol/section-project/assets/shieldBlue.png';

import linksDomik from 'src-sites/domik/links';
import linksBildControl from 'src-sites/bildcontrol/links';

import { renderMinPrice } from './render-min-price';
import {
  renderBlockMap, mapMarkerFunc, handleMarkerClickFunc,
  clickOutsideMapCardFunc, mapTileRendererFunc, handleScreenClickFunc
} from './render-block-map';
// import { checkStocks } from './common';
import {
  renterComplexItem,
  // renderSalesTitleAndStatuses,
  renderCreatorsListHorizontal,
  renderComplexProperties,
  dateLifeInfo,
  locType,
  renderCommonIconAndItem,
  renderSimpleLink,
  checkStocks,
  // renderStatusesRemain,
  renderStocksAndStatusesAll,
  renderSalerPhone,
  renderContactToDeveloper,
  renderDeveloperCallBack,
  checkIsHideJson
} from './render-common';
// import { renderRightColumn } from './render-right-column';
// import ContentComments from './content-comments';
import TileCard from './../section-projects/tile-card';
import { renderListCard } from './cards-object/cards';
// import marker from '../assets/map-marker';

import translates from './project-i18n';

const bemClasses = new Bem('project');
const bemClassesNearestLivingComplex = new Bem('landingLink');

const pointLevel = {
  NA: { img: imgShieldGray },
  lowLevel: { img: imgShieldRed },
  mediumLevel: { img: imgShieldYellow },
  highLevel: { img: imgShieldGreen },
  readyStatus: { img: imgShieldBlue }
};

@sensor
@I18nHoc(translates())
export default class Project extends Component {
  static propTypes = {
    project: PropTypes.shape({
      advanced_info: PropTypes.shape({}),
      stocks: PropTypes.shape({}),
      salers: PropTypes.arrayOf(PropTypes.shape({})),
      display_name: PropTypes.string,
      display_path: PropTypes.string,
      location_path: PropTypes.string,
      points: PropTypes.shape({}),
    }),
    seoData: PropTypes.shape({}),
    topic: PropTypes.string,
    childLandings: PropTypes.arrayOf(PropTypes.shape({})),
    pointsLevel: PropTypes.arrayOf(PropTypes.shape({})),
    objGroup: PropTypes.arrayOf(PropTypes.shape({})),
    creators: PropTypes.arrayOf(PropTypes.shape({})),
    mainDeveloperData: PropTypes.shape({}),
    nearestLC: PropTypes.shape({}),
    anchors: PropTypes.shape({}),
    commentsList: PropTypes.shape({}),
    terms: PropTypes.arrayOf(PropTypes.shape({})),
    isSensor: PropTypes.shape({}),
    scrollToRightColumn: PropTypes.func,
    landingUrl: PropTypes.shape({}),
    projBeforeObj: PropTypes.shape({}),
    renderAdvertBlock: PropTypes.func,
    projAfterObj: PropTypes.shape({}),
    isScrollToMap: PropTypes.bool
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.project = 'domik';

    this.renderObjects = this.renderObjects.bind(this);
    this.getInteractiveComponents = this.getInteractiveComponents.bind(this);
    // this.onScroll = this.onScroll.bind(this);
    // this.renderBlockIdentificationReliability = this.renderBlockIdentificationReliability.bind(this);

    this.mainDeveloperId = get(props, 'mainDeveloperData.id');

    this.state = {
      tagsTabSelected: 0,
      showStocksLC: false,
      houseInfo: null,
      showSoldPlans: {}
    };
  }

  static getDerivedStateFromProps(props, state) {
    const featureId = get(props, 'project.id');
    const { currentId } = state;

    if (featureId !== currentId) {
      return {
        isFullScreenMode: false,
        streetView: false,
        currentId: featureId,
        handleMarkerId: null
      };
    }
    return null;
  }

  componentDidMount() {
    // this.onScroll(this.sensor.getRuntime());
    this.showStocksLC();
    if (this.props.isScrollToMap) setTimeout(() => this.scrollToMap(), 1000);
  };

  /*
  onScroll(data) {
    const viewPortHeight = get(data, 'viewPortHeight');
    const catRef = this.catRef ? this.catRef.getBoundingClientRect() : null;
    const catBottom = get(catRef, 'bottom');

    if (catBottom <= viewPortHeight && !this.state.animatedCat) {
      this.setState({ animatedCat: true });
    }
  }
  */

  showHiddenPlans(type) {
    const showSoldPlansAll = get(this, 'state.showSoldPlans');
    const showSoldPlansType = get(this, `state.showSoldPlans[${type}]`);
    showSoldPlansAll[type] = !showSoldPlansType;

    this.setState({ showSoldPlans: showSoldPlansAll });
  }

  getInteractiveComponents(favData) {
    const { project } = this.props;
    const index = findIndex(favData, { entity_id: project.id });

    return (
      <FavoritesButton
        {...bemClasses('favorite')}
        project="domik"
        entity="location"
        entityId={project.id}
        subgroup="living_complex"
        inFavorites={index > -1}
        counterProps={{
          action: "favoritesProjectClick",
          entity:{
            project_id: project.id
          }
        }}
        hideLabel
      />
    );
  }

  scrollToMap =()=> {
    const isSensor = this.props.isSensor;
    const heightHeader = toNumber(isSensor.getVariable('heightHeaderPx'));

    scrollToComponent(this.refBlockMap, { offset: -heightHeader, align: 'top', duration: 300, ease: 'linear' });
  };

  mapMarker(point, latLng) { return mapMarkerFunc(point, latLng) }

  handleMarkerClick =(evt)=> handleMarkerClickFunc.call(this, evt);

  clickOutsideMapCard =(evt)=> clickOutsideMapCardFunc.call(this, evt);

  mapTileRenderer =payload=> mapTileRendererFunc.call(this, payload);

  handleScreenClick =()=> handleScreenClickFunc.call(this);

  showStocksLC =()=> {
    this.setState({ showStocksLC: true });
  };

  renderAnchors =({ data })=> {
    if (!data || data.length === 0) return null;

    return (
      <div {...bemClassesNearestLivingComplex()}>
        {map(data, (item, index) => (
          <div {...bemClassesNearestLivingComplex('item')} key={index}>
            <Link
              {...bemClassesNearestLivingComplex('link')}
              href={item.url}
              title={item.name}
            >
              <span {...bemClassesNearestLivingComplex('linkContent')}>
                <span {...bemClassesNearestLivingComplex('text', 'link')} children={item.name} />
              </span>
            </Link>
          </div>
        ))}
      </div>
    )
  }

  renderNearestLivingComplex =(data)=> {
    if (!data || !data.data || !data.data.length) return null;

    const { i18n } = this;
    const type = get(data, 'data[0].type');
    const txt = type === 'living_complex' ? i18n('nearestLivingComplexLCTopic') : i18n('nearestLivingComplexCTTopic');
    const dataNearest = get(data, 'data');

    return (
      <div {...bemClasses('blockNearestLivingComplex')}>
        <Row {...bemClasses('rowTopic')}>
          <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={txt} /></div></Col>
        </Row>
        <div {...bemClasses('projectsNearest')}>
          <FavoriteWrapper
            project={this.project}
            entity="location"
          >
            {({ data = {} }) => map(dataNearest, (item, key) => (
              <TileCard
                key={key}
                restProps={{ ...item }}
                object={item}
                favData={data}
              />
            ))}
          </FavoriteWrapper>
        </div>
        {/*
        <div {...bemClassesNearestLivingComplex()}>
          {map(data, (item, index) => (
            <div {...bemClassesNearestLivingComplex('item')} key={index}>
              <Link
                {...bemClassesNearestLivingComplex('link')}
                href={item.url}
                title={item.display_name}
              >
                <span {...bemClassesNearestLivingComplex('linkContent')}>
                  <span {...bemClassesNearestLivingComplex('text', 'link')} children={item.display_name} />
                </span>
              </Link>
            </div>
          ))}
        </div>
        */}
      </div>
    );
  };

  renderImage(data) {
    const { images: { others } = {}, display_name: title } = data;
    const { seoData } = this.props;

    if (!others || !others.length) {
      return (
        <>
          <Image
            {...bemClasses('imgPic')}
            image={{ alt: title, title }}
          />
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'ImageObject',
              name: title || null,
              description: title || null,
              contentLocation: get(data, 'locality_display_name', null)
            }}
          />
        </>
      );
    }

    return (
      <Slick {...bemClasses('imgPic')}>
        {map(others, (img, index) => (
          <Fragment key={index}>
            <Image
              image={getImages.call(this, img, { alt: seoData[`imgAlt${index+1}`] || title, title }).titleImage}
              group="livingComplexPhotos"
            />
            <JsonLd
              item={{
                '@context': 'https://schema.org',
                '@type': 'ImageObject',
                name: seoData[`imgAlt${index+1}`] || title || null,
                description: title || null,
                contentLocation: get(data, 'locality_display_name', null),
                contentUrl: get(img, 'id') ? absoluteUrl(`/images/thumb/full/${img.id}`) : null
              }}
            />
          </Fragment>
        ))}
      </Slick>
    );
  }

  /*
  renderStatistic(project) {
    const pageProjectView = +get(project, 'page_project_view', 0) + 1;

    return (
      <div {...bemClasses('onPhoto', 'views')}>
        <Icon {...bemClasses('icon', 'visibility')} type={iconTypes.visibility} />
        <span {...bemClasses('text', 'visibility')} children={pageProjectView} />
      </div>
    );
  }
  */

  handleChangeTabId =(tab)=> this.setState({ tagsTabSelected: tab.id });

  /*
  renderVideoOnPhoto(data, displayName) {
    if (!data || !data.val || !data.val[0]) return null;

    return (
      <div {...bemClasses('onPhoto', 'video')}>
        <Link
          {...bemClasses('link', 'video')}
          href={data.val[0]}
          title="Смотреть видеобзор"
          dataProps={displayName ? { 'data-gtm-zhk': displayName } : null}
          rel="nofollow"
          external
          blank
        >
          <span {...bemClasses('linkContent')}>
            <Icon {...bemClasses('icon')} type={iconTypes.videoBild} />
            <span {...bemClasses('text', 'link')} children="Смотреть видеобзор" />
          </span>
        </Link>
      </div>
    );
  }
  */

  renderObjects() {
    const { i18n } = this;
    const { tagsTabSelected } = this.state;
    const {
      childLandings, seoData = {}, project = {} //, objGroup = []
    } = this.props;
    const { advanced_info = {}, all_flats_sold, all_commercial_sold, all_house_and_area_sold, ...rest } = project;
    const propsGroup = { ...advanced_info, all_flats_sold, all_commercial_sold, all_house_and_area_sold, ...rest };
    const soldData = { all_flats_sold, all_commercial_sold, all_house_and_area_sold };
    const dateLife = get(project, 'date_life');
    const topic = seoData && seoData.plansHeader ? seoData.plansHeader : i18n('developerSale');
    const tabs = [];
    const childTabs = [];
    let idx = 0;

    tabs.push(
      <tab
        key="allObjects"
        id={idx}
        title={i18n('btnAllText')}
      />
    );

    const filterChildLandingsAll = childLandings.filter(n => n.level !== 2 && n.subgroup);

    childTabs.push(
      <Fragment key="allObjects">
        <div {...bemClasses('purchaseOptions')}>
          {renderListCard.call(this, filterChildLandingsAll, 'living_complex', soldData, false, project)}
        </div>
        <div
          {...bemClasses('dateLifeInfo')}
          children={dateLifeInfo.call(this, bemClasses, dateLife, i18n('objects'))}
        />
      </Fragment>
    );

    each(childLandings, (land, key) => {
      if (land.subgroup === 'objGrp') {
        idx += 1;
        const { data } = land;
        const { groupId } = data;
        const name = data.value.sectionName;
        const groupName = get(land, 'data.value.groupName');
        const filterChildLandings = childLandings.filter(
          n => n.data.groupId === groupId && n.level !== 2 && n.subgroup
        );

        tabs.push(
          <tab
            key={key}
            id={idx}
            title={name}
          />
        );

        childTabs.push(
          <Fragment key={key}>
            <div {...bemClasses('purchaseOptions')}>
              {renderListCard.call(this, filterChildLandings, 'living_complex', soldData, false, project)}
            </div>
            <div
              {...bemClasses('dateLifeInfo')}
              children={dateLifeInfo.call(this, bemClasses, dateLife, groupName)}
            />
          </Fragment>
        );
      }
    });
    //if (childTabs.length + rest.stocks_array.length === 0) return null;

    return (
      <div {...bemClasses('plansList')}>
        <Row {...bemClasses('rowTopic')}>
          <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={topic} /></div></Col>
        </Row>
        {tabs.length !== 0 &&
          <>
            <TabJSControl
              {...bemClasses('tab')}
              selectedTab={tagsTabSelected}
              onChange={this.handleChangeTabId}
              aside={renderContactToDeveloper.call(this, bemClasses, i18n('wantDiscount'))}
            >
              {tabs}
            </TabJSControl>
          </>
        }
        {tabs.length !== 0 && childTabs[tagsTabSelected]}
        <LazyHydrate whenIdle>
          <Row {...bemClasses('row', 'purchaseOptionsRow')}>
            {renderPurchaseOptions.call(this, propsGroup)}
            {renderBlockStocks.call(this, rest.stocks_array, propsGroup)}
          </Row>
        </LazyHydrate>
      </div>
    );
  }

  renderLinkPublication(href, text, otherLinkProps) {
    return (
      <Link
        {...bemClasses('link', 'more')}
        href={href}
        title={text}
        noRedirector
        external
        blank
        {...otherLinkProps}
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text')} children={text} />
        </span>
      </Link>
    );
  }

  /*
  renderPublications(data) {
    if (!data || !data.length || !get(data, '[0].head')) return null;

    const { i18n } = this;
    const lang = get(this, 'context.lang');
    const dataSortedByDate = sortBy(data, 'article_date').reverse();
    const typeTxt = locType.call(this, get(this, 'props.project.data[0].type'));
    const topic = i18n('publicationsTopic', { placeholder: typeTxt });
    // const dataSlice = data.slice(0, 2);
    const publicationItem =
      map(dataSortedByDate, (it, index) => (
        <Col key={index} {...bemClasses('col', 'publication')} allFlex allColumn allPr={0}>
          <div {...bemClasses('topic')}>
            {this.renderLinkPublication(it.publication_link, it.head)}
          </div>
          <div {...bemClasses('date')}>
            <span
              {...bemClasses('text', 'date')}
              children={formatDate(
                { date: it.article_date, render: 'date', format: 'd mmmm yyyy' },
                lang
              )}
            />
          </div>
          <div {...bemClasses('description')}>
            <span {...bemClasses('text')} dangerouslySetInnerHTML={{ __html: it.description }} />
          </div>
          <div {...bemClasses('more')}>
            {this.renderLinkPublication(it.publication_link, i18n('moreDetails'), { rel: 'nofollow' })}
          </div>
        </Col>
      ));
    const filterPublicationItem = publicationItem.filter(Boolean);

    if (!filterPublicationItem.length) return null;

    return (
      <div {...bemClasses('blockPublications')}>
        <Row {...bemClasses('rowTopic')}>
          <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={topic} /></div></Col>
        </Row>
        <Row {...bemClasses('row', 'content')} mpColumn>
          {filterPublicationItem}
        </Row>
        <JsonLd
          item={{
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            name: topic,
            about: topic,
            mainEntity: map(dataSortedByDate, it => ({
              '@type': 'Question',
              name: it.head,
              acceptedAnswer: {
                '@type': 'Answer',
                dateCreated: it.article_date,
                text: it.description,
                url: it.publication_link
              }
            }))
          }}
        />
      </div>
    );
  }
  */

  renderBlockCreators(creators) {
    if (!creators || !creators[0]) return null;

    return (
      <div {...bemClasses('creators')}>
        <Row {...bemClasses('rowTopic')}>
          <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={this.i18n('developerTopic')} /></div></Col>
        </Row>
        {renderCreatorsListHorizontal.call(this, bemClasses, creators)}
      </div>
    );
  }

  renderHouseInfo() {
    if (!this.state.houseInfo) {
      return null;
    }
    return JSON.stringify(this.state.houseInfo);
  }

  renderDescriptionAndFirstPage(data) {
    const { i18n } = this;

    return (
      <div {...bemClasses('blockDescription')}>
        <Row {...bemClasses('row', 'makeOrder')} mpColumn allJustifyCCenter={!data}>
          {data &&
            <Col {...bemClasses('col', 'description')} allPr={0}>
              <Row {...bemClasses('rowTopic')}>
                <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={i18n('descriptionTopic')} /></div></Col>
              </Row>
              <div {...bemClasses('content')}>
                <div
                  {...bemClasses('text', 'description')}
                  dangerouslySetInnerHTML={{ __html: data }}
                />
                {/*
                <CollapseLines
                  itemClassName={bemClasses('text', 'description').className}
                  text={data}
                  otherProps={{
                    btnProps: { iconSecondType: '' }
                  }}
                  moreText={i18n('readMore')}
                  linesConfig={{
                    desktop: 11,
                    tablet: 15,
                    phone: 16
                  }}
                />
                */}
              </div>
            </Col>
          }
          <Col {...bemClasses('col', 'pdf')} allFlex allColumn mdAuto mtAuto allPr={0} allAlignICenter={!data}>
            <div {...bemClasses('colContent')} children={this.firstPage()} />
          </Col>
        </Row>
      </div>
    );
  }

  firstPage =()=> {
    const { i18n } = this;
    const { project = {} } = this.props;
    const {
      points = {}, reliability_to_publish, display_name, status_ready, bildcontrol_url
    } = project;
    const pointsFilled = get(points, 'investorConfidence.filled');
    const pointsAll = get(points, 'investorConfidence.all');
    const level = get(points, 'level');
    const textChangeStatus = status_ready ? i18n('putIntoOperation') : i18n('newBuildingReliabilityIndex');
    const pointsTxt = reliability_to_publish ? (
      <>
        <div {...bemClasses('text', 'pointsAll')} children={`${i18n('ofText')} ${pointsAll}`} />
        <div {...bemClasses('text', 'points')} children={pointsFilled} />
      </>
    ) : <span {...bemClasses('text', 'points')} children={i18n('naText')} />;

    return (
      <div {...bemClasses('pdf', { [level]: level })}>
        <div {...bemClasses('logo')}>
        <span {...bemClasses('logoContent')}>
          <Icon {...bemClasses('icon', 'icon')} type={iconTypes.logoBildControl} />
          <Icon {...bemClasses('icon', 'logo')} type={iconTypes.logoBildControlText} />
        </span>
        </div>
        <div {...bemClasses('imgContainer')}>
          <img {...bemClasses('img')} src={get(pointLevel, `${level}.img`)} alt="" loading="lazy" decoding="async" />
        </div>
        <div {...bemClasses('topic')}>
          <span {...bemClasses('text')} children={display_name} />
        </div>
        <Row {...bemClasses('row', 'points')}>
          <Col {...bemClasses('col', 'text')} allPr={0}>
            <span {...bemClasses('text')} children={textChangeStatus} />
          </Col>
          {!status_ready &&
            <Col {...bemClasses('col', 'points')} allAuto allPr={0}>
              <div {...bemClasses('pointsText')} children={pointsTxt} />
            </Col>
          }
        </Row>
        {!status_ready &&
          <Link
            {...bemClasses('link', 'toBC')}
            builder={linksBildControl.sectionLanding}
            builderProps={{ url: bildcontrol_url, title: i18n('checkLC') }}
            noRedirector
            external
            blank
          >
            <span {...bemClasses('linkContent')}>
              <span {...bemClasses('text', 'link')} children={i18n('checkLC')} />
            </span>
          </Link>
        }
      </div>
    )
  };

  handleMapHouseClick =(event)=> {
    const feature = event.target.feature;
    this.setState({
      houseInfo: feature.properties
    });
  };

  renderBlockTerms(terms) {
    if (!terms || !terms.length) return null;

    const { i18n } = this;

    return (
      <>
        <div {...bemClasses('deadline', 'table')}>
          <table {...bemClasses('table')}>
            <thead>
              <tr {...bemClasses('tableRow', 'thead')}>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic1')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic2')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic3')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic4')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic5')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic6')} /></th>
                <th {...bemClasses('tableCol')}><span {...bemClasses('text')} children={i18n('tableDeadlineTopic7')} /></th>
              </tr>
            </thead>
            <tbody>
              {map(terms, (it, key) => {
                let longTermsTxt = it.longTermMonths ? i18n('tableColDelayedDeliveryText', {
                  placeholderRU: numDesc(it.longTermMonths, 'месяц', 'месяца', 'месяцев'),
                  placeholderUA: numDesc(it.longTermMonths, 'місяць', 'місяця', 'місяців')
                }) : '';
                if (longTermsTxt && it.put_into_operation_quarter && it.put_into_operation_year) {
                  longTermsTxt = `${i18n('readyText')}. ${longTermsTxt}`;
                }
                if (!longTermsTxt) {
                  if (it.put_into_operation_quarter && it.put_into_operation_year) {
                    if (it.ready_quarter && it.ready_year) longTermsTxt = i18n('readyOnTimeText');
                    if (!it.ready_quarter || !it.ready_year) longTermsTxt = i18n('readyText');
                  }
                  if (!it.put_into_operation_quarter || !it.put_into_operation_year) {
                    if (it.ready_quarter && it.ready_year) longTermsTxt = i18n('deadlineHasNotComeText');
                  }
                }

                const last_date = get(it, 'date_edit') || get(it, 'date') || '';

                return (
                  <tr key={key} {...bemClasses('tableRow')}>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={it.name} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={it.ready_quarter} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={it.ready_year} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={longTermsTxt} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={it.put_into_operation_quarter} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={it.put_into_operation_year} /></td>
                    <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={formatDate({ date: get(last_date.split(' '), '[0]'), format: 'dd.mm.yyyy' })} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <span {...bemClasses('text', 'dateLife')} children={i18n('tableDeadlineAfterText')} />
      </>
    )
  }

  renderProgressAndTerms(terms, rest) {
    const progressArr = get(rest, 'construction_progress_array');

    if ((!terms || !terms.length) && checkIsEmpty(progressArr)) return null;

    const { i18n } = this;
    const constructionProgressLink = get(rest, 'construction_progress_link', null);
    const displayName = get(rest, 'display_name', '');
    // const txtLink = this.i18n('linkShowAllPlansText');
    const displayNameSeo = get(rest, 'seo_names') ? ` ${get(rest, 'typeData.name_short')} ${get(rest, 'seo_names')}` : ` ${displayName}`;

    return (
      <div {...bemClasses('blockConstructionProgress')}>
        <Row {...bemClasses('rowTopic')} mpColumn>
          <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={`${i18n('constructionProgressTopic')}${displayNameSeo}`} /></div></Col>
          {constructionProgressLink &&
            <Col {...bemClasses('col', 'link')} mdAuto mtAuto allPr={0}>
              <Link
                {...bemClasses('link', 'toConstructionProgress')}
                href={constructionProgressLink}
                title={`${i18n('constructionProgressTopic')} ${i18n('constructionProgressOnWebsiteLC')}`}
                dataProps={displayName ? { 'data-gtm-zhk': displayName } : null}
                rel="nofollow"
                external
                blank
              >
                <span {...bemClasses('linkContent')}>
                  <span {...bemClasses('text', 'link')} children={`${i18n('constructionProgressTopic')} ${i18n('constructionProgressOnWebsiteLC')}`} />
                </span>
              </Link>
            </Col>
          }
        </Row>
        <div {...bemClasses('content')}>
          {renderBlockConstructionProgress.call(this, progressArr, displayName, 6)}
          {this.renderBlockTerms(terms)}
        </div>
      </div>
    );
  }

  renderOverflight =(link)=> {
    const { i18n } = this;

    return (
      <YoutubeIframe
        className={bemClasses}
        videoId={link}
        otherProps={{
          btnToVideoProps: {
            label: i18n('overflight'),
            title: i18n('overflight'),
            iconType: iconTypes.overflight,
            contentLeft: true
          }
        }}
      />
    );
  }

  render() {
    const { i18n } = this;
    const {
      project = {}, creators, topic, anchors = {}, nearestLC = {}, // pointsLevel, childLandings, commentsList,
      renderAskQuestion, landing, terms, projBeforeObj, projAfterObj, renderAdvertBlock //, isSensor, scrollToRightColumn
    } = this.props;
    const alien = get(project, 'product.addition_fields.alien');
    const {
      id, advanced_info = {}, display_name, display_path, location_path, title_image, status_ready, ...rest
    } = project;
    const propsGroup = { ...advanced_info, ...rest };
    const url = get(landing, 'url', '');
    const urlComplaint = url;
    const fullAddress = get(propsGroup, 'fullAddress.address', null);
    const header = fullAddress || display_path || location_path;
    const {
      min_price, overflight_link// reliability_for_whom, problem_desc, points, type, display_name, completion
      // all_flats_sold, all_commercial_sold, all_house_and_area_sold, sales_suspended_until,
    } = propsGroup;
    // const publicationsArray = get(propsGroup, 'publications_array');
    // const soldData = { all_flats_sold, all_commercial_sold, all_house_and_area_sold };
    rest.geo.parameters = { distance: 10000 };
    const imageId = get(title_image, 'id');
    // const isNoDesktop = get(isSensor, 'runtime.media.tablet') || get(isSensor, 'runtime.media.phone');
    const toponymLabel = (
      <div {...bemClasses('location')}>
        {header &&
          <div {...bemClasses('address')}>
            <span {...bemClasses('text')} children={header} />
            &ensp;
          </div>
        }
        <div {...bemClasses('itemGroup', 'toponymMain')}>
          {renterComplexItem.call(this, bemClasses, ['toponym'])}
        </div>
      </div>
    );
    let description = rest.description;

    return (
      <>
        <LazyHydrate ssrOnly>
          <OpenGraphImage imageId={imageId} />
        </LazyHydrate>
        {/*
        <Row {...bemClasses('row', 'imgBefore')} mtColumn mpColumn>
          <Col {...bemClasses('col', 'location')} allFlex allPr={0}>
            <Button
              {...bemClasses('btn', 'location')}
              onClick={this.scrollToMap}
              label={toponymLabel}
              title={i18n('btnToLocation')}
            />
            {renderMinPrice.call(this, bemClasses, min_price, soldData, sales_suspended_until, ['minPrice'], { priceMain: true })}
          </Col>
        </Row>
        */}
        <Row {...bemClasses('row', 'mainInfo')} mtColumn mpColumn>
          <Col {...bemClasses('col', 'img')} mdOrder={1} allPr={0}>
            <div {...bemClasses('block', 'img')}>
              <div {...bemClasses('img', 'main')}>
                {this.renderImage(project)}
                {overflight_link && this.renderOverflight(overflight_link)}
                {renderStocksAndStatusesAll.call(this, bemClasses, rest)}
                {/* {this.renderStatistic(project)} */}
                <FavoriteWrapper project="domik" entity="location">
                  {({ data }) => this.getInteractiveComponents(data)}
                </FavoriteWrapper>
              </div>
            </div>
          </Col>
          <Col {...bemClasses('col', 'mainInfo')} mdAuto allPr={0}>
            <div {...bemClasses('block', 'info')}>
              <div {...bemClasses('title')}>
                <div {...bemClasses('text')}><h1 children={topic} /></div>
              </div>
              <div {...bemClasses('locationContainer')}>
                <div
                  {...bemClasses('btn', 'location', 'btn')}
                  onClick={this.scrollToMap}
                  title={i18n('btnToLocation')}
                >
                  <div
                    {...bemClasses('btnContent', null, 'btn__content')}
                    children={toponymLabel}
                  />
                </div>
              </div>
              {renderMinPrice.call(this, bemClasses, min_price, {}, null, ['minPrice'], { priceMain: true })}
              {renderMainInfo.call(this)}
            </div>
          </Col>
        </Row>
        {alien && renderAdvertBlock('projBeforeObj')}
        {this.renderObjects()}
        {projAfterObj}
        {renderBlockComplaint.call(this, id, urlComplaint, bemClasses)}
        {renderComplexYoutube.call(this, bemClasses)}
        <div {...bemClasses('block', 'info horizontal')}>
          {renderMainInfo.call(this)}
          {getPartners.call(this, this.mainDeveloperId, creators)}
        </div>
        <LazyHydrate whenVisible>
          {renderBlockMap.call(this, project, landing)}
        </LazyHydrate>
        {alien && renderAdvertBlock('advertBlock2')}
        <DataProvider
          preloaded={anchors}
          preloadedStatic
          renderer={this.renderAnchors}
        />
        {renderComplexProperties.call(this, bemClasses)}
        <AdSense {...bemClasses('blockAdSense')} />
        {renderOverflights.call(
          this,
          rest.overflights_array,
          6,
          topic
        )}
        {this.renderProgressAndTerms(terms, {...rest, display_name})}
        {this.renderDescriptionAndFirstPage(description)}
        <AdSense {...bemClasses('blockAdSense')} />
        {renderAskQuestion(id, project, url)}
        {/*
        <LazyHydrate whenIdle>
          {problem_desc &&
            <Row {...bemClasses('blockReliabilityDescription', 'problem')} mpColumn>
              <Col allPr={0}>
                <span {...bemClasses('text')}>
                  <Icon {...bemClasses('icon', 'info')} type={iconTypes.infoCircleBorder} />
                  <span dangerouslySetInnerHTML={{ __html: problem_desc }} />
                </span>
              </Col>
            </Row>
          }
          {completion &&
            <Row {...bemClasses('blockReliabilityDescription', 'problem')} mpColumn>
              <Col allPr={0}>
                  <span {...bemClasses('text')}>
                    <span dangerouslySetInnerHTML={{ __html: completion }} />
                  </span>
              </Col>
            </Row>
          }
          {this.renderBlockIdentificationReliability(
            reliability_for_whom, points, pointsLevel, type, rest.url
          )}
        </LazyHydrate>
        {this.renderBlockCreators(creators)}
        {this.renderPublications(publicationsArray)}
        <LazyHydrate whenVisible>
          <ContentComments
            project={project}
            childLandingsData={childLandings}
            commentsList={commentsList}
            commentsProps={{
              subscribe: false,
              topic: display_name,
              showCountNewComments: false,
              noVisitingCard: true
            }}
          />
        </LazyHydrate>
        */}
        <DataProvider
          preloaded={nearestLC.nearestLC}
          preloadedStatic
          renderer={this.renderNearestLivingComplex}
        />
      </>
    );
  }
}

function isLink(arr) {
  let isLink = false;

  map(arr, it => {
    if (it.link) isLink = true;
  });

  return isLink;
}

function rendererJsonData(data, jsonData = {}) {
  if (checkIsHideJson.call(this, data)) return null;

  return (
    <JsonLd
      item={{
        '@context': 'https://schema.org',
        ...jsonData,
        organizer: 'Domik.ua'
      }}
    />
  );
}

function renderPurchaseOptionsItem(field, projectData) {
  const arr = get(projectData, field);

  if (!isLink(arr)) return null;

  const { i18n } = this;
  const config = {
    installment_plan_array: {
      textTopic: i18n('installment'),
      iconType: 'installment',
      substrate: (
        <Icon
          {...bemClasses('icon', 'installment')}
          type={iconTypes.installment}
          substrate={`<span class="${bemClasses('img', 'substrate installment').className}"></span>`}
        />
      )
    },
    credits_array: {
      textTopic: i18n('credit'),
      iconType: 'moneyBank',
      substrate: (
        <span {...bemClasses('icon', 'moneyBank', 'icon')}>
          <span {...bemClasses('img', 'substrate moneyBank')} children="%" />
        </span>
      )
    }
  };
  const { display_name, date_add, address, locality_display_name } = projectData;

  return (
    <Col {...bemClasses('col', 'purchaseOptionsCol')} allFlex allColumn allPr={0}>
      <Slick {...bemClasses('slider', 'stocks')}>
        {map(get(projectData, field), (data, key) => {
          const linkVal = get(data, `link`);

          if (!linkVal) return null;

          const textDescription = get(data, 'domik_description');
          const logo = get(data, 'logo');
          const image = typeof logo === 'string' ? { id: logo } : logo;
          const textTopic = get(config, `${field}.textTopic`);
          const ava = { ...image, alt: textDescription, title: textTopic };
          const seoTitle = `\ud83d\udd36 ${textTopic}`;
          const icon = logo ? (
            <>
              <Thumb
                {...bemClasses('icon', 'ava')}
                image={ava}
              />
              <JsonLd
                item={{
                  '@context': 'https://schema.org',
                  '@type': 'ImageObject',
                  name: get(ava, 'alt', null),
                  description: get(ava, 'title', null),
                  contentUrl: logo ? absoluteUrl(`/images/thumb/full/${logo.id}`) : null
                }}
              />
            </>
          ) : get(config, `${field}.substrate`);

          return (
            <Fragment key={key}>
              <Row {...bemClasses('row', 'event')}>
                <Col {...bemClasses('col', 'icon')} allAuto allPr={0} children={icon} />
                <Col {...bemClasses('col', 'info')} allFlex allColumn allJustifyCCenter allPr={0}>
                  <div {...bemClasses('topic')}>
                    <Link
                      {...bemClasses('link', 'more')}
                      href={linkVal}
                      title={i18n('checkWithDeveloper')}
                      rel="nofollow"
                      dataProps={display_name ? { 'data-gtm-zhk': display_name } : null}
                      external
                      blank
                    >
                      <span {...bemClasses('linkContent')}>
                        <span {...bemClasses('text')} children={textTopic} />
                      </span>
                    </Link>
                  </div>
                  <div {...bemClasses('description')}>
                    {textDescription &&
                      <><span {...bemClasses('text')} children={textDescription} />&ensp;</>
                    }
                  </div>
                  {renderDeveloperCallBack.call(this, bemClasses)}
                </Col>
              </Row>
              {rendererJsonData.call(this, projectData, {
                '@type': 'Event',
                name: seoTitle,
                description: textDescription,
                url: linkVal,
                startDate: date_add,
                location: {
                  '@type': 'Place',
                  name: display_name,
                  address: {
                    '@type': 'PostalAddress',
                    addressLocality: locality_display_name,
                    streetAddress: address
                  }
                },
                performer: display_name
              })}
            </Fragment>
          )
        })}
      </Slick>
    </Col>
  );
}

function checkIsEmpty(array) {
  if (!array || !array.length) return true;

  let answer = true;
  map(array, (obj) => {
    map(obj, (it) => {
      if (it) answer = false;
    });
  });

  return answer;
}

function renderBlockConstructionProgress(
  constructionProgressArray, displayName, slicedNumber
) {
  if (checkIsEmpty(constructionProgressArray)) return null;

  const { i18n } = this;
  const lang = get(this, 'context.lang');
  const title = `${i18n('constructionProgressTopic')} ${displayName}`;
  const sortByDate =
    sortBy(constructionProgressArray, item => item.construction_progress_month).reverse();
  const slicedArr = sortByDate.slice(0, slicedNumber);
  const breakpointDesktop = (this.sensor.getVariable('breakpointDesktop') || 1280) - 1;
  const breakpointTablet = (this.sensor.getVariable('breakpointTablet') || 768) - 1;

  return (
    <Slick
      slidesToShow={3}
      slidesToScroll={1}
      responsive={[
        {
          breakpoint: breakpointDesktop,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: breakpointTablet,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]}
      dots={true}
      // dotsClass="lolo"
      //{...bemClasses('imgPic')}
    >
      {map(slicedArr, (item, key) => {
        const date = getOnlyMonthAndYear(item.construction_progress_month, lang);
        const altMonthAndYear = formatDate(
          { date: item.construction_progress_month, format: `, mmm, yyyy ${i18n('year')}` },
          lang
        );
        const alt = `${title}${altMonthAndYear}`;
        const image = get(item, 'construction_progress_image');
        const topic = date ? <div {...bemClasses('text', 'topicFullScreen')} children={date} /> : null;

        return (
          <div key={key} {...bemClasses('imgContainer')}>
            <div {...bemClasses('img')}>
              <Image
                {...bemClasses('imgPic')}
                image={{...getImages.call(this, item.construction_progress_image, { alt, title }).titleImage, topic}}
                group="buildingProgress"
              />
              <div {...bemClasses('onPhoto')}>
                <div {...bemClasses('text')} children={date} />
              </div>
              <JsonLd
                item={{
                  '@context': 'https://schema.org',
                  '@type': 'ImageObject',
                  name: alt || null,
                  description: title || null,
                  contentUrl: image ? absoluteUrl(`/images/thumb/full/${image}`) : null
                }}
              />
            </div>
          </div>
        );
      })}
    </Slick>
  );
}

export function renderPurchaseOptions(data) {
  const credits_array = get(data,'credits_array') || [];
  const installment_plan_array = get(data,'installment_plan_array') || [];
  const arr = [
    ...credits_array,
    ...installment_plan_array
  ];

  if (!isLink(arr)) return null;

  return (
    <>
      {renderPurchaseOptionsItem.call(this, 'installment_plan_array', data)}
      {renderPurchaseOptionsItem.call(this, 'credits_array', data)}
    </>
  );
}

export function renderBlockStocks(data, otherData) {
  if (!data || !data.length) return null;

  const { i18n } = this;
  const displayName = get(otherData, 'display_name');
  const streetAddress = get(otherData, 'address');
  const addressLocality = get(otherData, 'locality_display_name');
  const stockItem = map(data, (it, index) => {
    const checkedStocks = checkStocks(it);

    if (!checkedStocks) return null;

    const isDiscount = get(it, 'discount', null);
    const seoTitle = `\ud83d\udd36 ${get(it, 'title_domik')}`;
    const discount = isDiscount ? ` ${it.discount}` : '';
    let iconEvent = (
      <Icon
        {...bemClasses('icon', 'stock present')}
        type={iconTypes.gift}
      />
    );
    const stocksLink = (
      <Link
        {...bemClasses('link', 'more')}
        href={it.link}
        title={i18n('checkWithDeveloper')}
        dataProps={displayName ? { 'data-gtm-zhk': displayName } : null}
        rel="nofollow"
        external
        blank
      >
        <span {...bemClasses('linkContent')}>
          <span {...bemClasses('text')} children={`${i18n('stock')}${discount}`} />
        </span>
      </Link>
    );

    if (isDiscount) {
      iconEvent = <span {...bemClasses('icon', 'stock', 'icon')} children={it.discount} />
    } else if (get(it, 'finflash')) {
      iconEvent = (
        <Icon
          {...bemClasses('icon', 'stock finflash')}
          type={iconTypes.finflash}
        />
      );
    }

    return (
      <Fragment key={index}>
        <Row {...bemClasses('row', 'event')}>
          <Col {...bemClasses('col', 'icon')} allAuto allPr={0} children={iconEvent} />
          <Col {...bemClasses('col', 'info')} allFlex allColumn allJustifyCCenter allPr={0}>
            <div {...bemClasses('topic')} children={stocksLink} />
            <div {...bemClasses('description')}>
              {it.title_domik &&
                <><span {...bemClasses('text')} children={it.title_domik} />&ensp;</>
              }
            </div>
            {renderDeveloperCallBack.call(this, bemClasses)}
          </Col>
        </Row>
        {rendererJsonData.call(this, otherData, {
          '@type': 'SaleEvent',
          name: seoTitle,
          startDate: it.period_date_from,
          endDate: it.period_date_to,
          url: it.link,
          description: it.discount,
          location: {
            '@type': 'Place',
            address: {
              '@type': 'PostalAddress',
              streetAddress,
              addressLocality
            },
            name: displayName
          },
          about: it.title_domik,
          performer: displayName,
        })}
      </Fragment>
    );
  });
  const filterStockItem = stockItem.filter(Boolean);

  if (!filterStockItem.length) return null;

  return (
    <Col {...bemClasses('col', 'purchaseOptionsCol')} allFlex allColumn allPr={0}>
      <Slick {...bemClasses('slider', 'stocks')}>
        {filterStockItem}
      </Slick>
    </Col>
  );
}

export function renderMainInfo() {
  const { project = {}, mainDeveloperData /*, isSensor*/ } = this.props;
  const { advanced_info = {}, display_name /*, salers*/} = project;
  const { complex_sites /*, complex_forums*/ } = advanced_info;
  // const isNoDesktop = get(isSensor, 'runtime.media.tablet') || get(isSensor, 'runtime.media.phone');
  // const isPhone = get(isSensor, 'runtime.media.phone');
  // const timeOfBeginning = get(salers, '[0].time_of_beginning');
  // const timeOfEnding = get(salers, '[0].time_of_ending');
  // const workTime = timeOfBeginning && timeOfEnding ? `${timeOfBeginning} - ${timeOfEnding}` : null;

  return (
    <>
      {renderMainDeveloper.call(this, mainDeveloperData, complex_sites, project.id)}
      <div {...bemClasses('item', 'list')}>
        {complex_sites &&
          renderCommonIconAndItem.call(
            this,
            bemClasses,
            iconTypes.planetThin,
            complex_sites,
            ['complex_sites'],
            {},
            { 'data-gtm-zhk': display_name }
          )
        }
        {renderForumLink.call(this)}
        {/*TODO Веталь БЛЯТЬ ниже пример функции в которой передается 6 переменных, в ней сука вызывается другая функция уже с 7ю переменными. А в последней функии прописано
          if (url) {
            linkProps.blank = true;
          }
          мне всего лишь нужно открывать в том же окне.
          Спецом написал новую функцию. Потратил на это больше часа, чтоб все стили совпадали. Иконки и т.п
          Не добавляй новых переменных в функцию. ПРсто пиши новую. ЯРКИЙ ПРИМЕР трудно поддерживаемого проекта.
        */}
        {/*renderCommonIconAndItem.call(
          this,
          bemClasses,
          iconTypes.commentInvert,
          complex_forums,
          ['complex_forums'],
          { forum: true }
        )*/}
        {/*
        {!!workTime &&
          <div {...bemClasses('item', 'row time')}>
            <span {...bemClasses('text', 'icon')}>
              <Icon {...bemClasses('icon')} type={iconTypes.clock} />
            </span>
            <span {...bemClasses('text', 'colRight')}>
              <span {...bemClasses('text')} children={workTime} />
            </span>
          </div>
        }
        */}
      </div>
      {/*
      <div {...bemClasses('item', 'toSite')}>
        {complex_sites &&
          renderSimpleLink.call(this, bemClasses, { url: get(complex_sites, 'val[0]'), dataProps: { 'data-gtm-zhk': display_name } }, true, { toSite: true })
        }
      </div>
      */}
      <div {...bemClasses('item', 'telQuestion')}>
        {renderSalerPhone.call(this, bemClasses)}
        {renderContactToDeveloper.call(this, bemClasses)}
      </div>
    </>
  );
}

function renderMainDeveloper(mainDeveloper, complex_sites, idProject = null) {
  if (!mainDeveloper || !Object.keys(mainDeveloper).length) return null;

  const { avatar, name, company_name } = mainDeveloper;
  const image = (typeof avatar === 'string' || !avatar) ? { id: avatar } : avatar;
  const avatarDeveloper = { ...image, alt: name, title: company_name };
  //const complex_sites_href = get(complex_sites, 'val[0]');

  return (
    <div {...bemClasses('developerMain')}>
      <div {...bemClasses('imgContainer')}>
        <div {...bemClasses('img')}>
          {renderSimpleLink(
            bemClasses,
            { builder: linksDomik.sectionLanding, builderProps: mainDeveloper, text: name },
            false,
            { fill: true },
            false,
            { entity: { developer_id: mainDeveloper.id, project_id: idProject }, action: 'siteDeveloperClick' }
          )}
          {/*TODO Веталь нужно почистить стили*/}
          {/*complex_sites_href &&
            <Counter
              action="siteDeveloperClick"
              entity={{
                project_id: 'project.id',
                developer_id: mainDeveloper.id
              }}
              mode="click"
              injectClickName="onClick"
            >
              <Link
                {...bemClasses('link', 'fill')}
                href={complex_sites_href}
                title={name || complex_sites_href}
                dataProps={company_name ? { 'data-gtm-dev': company_name } : null}
                rel="nofollow"
                external
                blank
              >
                <span />
              </Link>
            </Counter>
          */}
          <Thumb
            {...bemClasses('imgPic')}
            image={avatarDeveloper}
            tagSpan
          />
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'ImageObject',
              name: get(avatarDeveloper, 'alt', null),
              description: get(avatarDeveloper, 'title', null),
              contentUrl: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null
            }}
          />
        </div>
      </div>
      <div {...bemClasses('developerTopicPosition')}>
        <div {...bemClasses('developerPosition')} children={this.i18n('developerTopic')} />
        {renderSimpleLink(
          bemClasses,
          { builder: linksDomik.sectionLanding, builderProps: mainDeveloper, text: name },
          false,
          { developer: true },
          false,
          false
        )}
      </div>
    </div>
  );
}

export function getPartners(mainDeveloperId, creators) {
  const partnersArr = filter(creators, val => val.id !== mainDeveloperId);

  if (!partnersArr.length) return null;

  return (
    <div {...bemClasses('partners')}>
      <div {...bemClasses('item', 'label')}>
        <span {...bemClasses('text', 'label')} children={this.i18n('partnersProject')} />
      </div>
      <div {...bemClasses('item', 'partners')}>
        {map(partnersArr, (it, index) =>
          <Fragment key={index}>
            {renderSimpleLink(bemClasses, { builder: linksDomik.sectionLanding, builderProps: it, text: it.name })}
          </Fragment>
        )}
      </div>
    </div>
  );
}

export function renderComplaint(id, url, bemClasses) {
  const { i18n } = this;

  return (
    <Complaint
      {...bemClasses('btn', 'complaint')}
      entity="newbuild"
      entityId={id}
      withIcon
      buttonTitle={i18n('btnComplaintText')}
      buttonLabel={i18n('btnComplaintText')}
      buttonIcon={iconTypes.exclamationBorder}
      url={url}
    />
  );
}

export function renderBlockComplaint(id, url, bemClasses) {
  const { i18n } = this;

  return (
    <Row {...bemClasses('blockComplaint')} mpColumn>
      <Col {...bemClasses('col', 'text')} allPr={0}><div {...bemClasses('text')}><span children={i18n('blockComplaintText')} /></div></Col>
      <Col {...bemClasses('col', 'btn')} allAuto allPr={0}>
        {renderComplaint.call(this, id, url, bemClasses)}
      </Col>
    </Row>
  );
}

export function renderComplexYoutube(bemClasses) {
  const { i18n } = this;
  const complex_youtube = get(this, 'props.project.advanced_info.complex_youtube.val');
  const typeTxt = locType.call(this, get(this, 'props.project.data[0].type'));

  if (!complex_youtube || !complex_youtube.length) return null;

  return (
    <LazyHydrate whenVisible>
      <div {...bemClasses('blockComplexYoutube')}>
        <Row {...bemClasses('rowTopic')} mpColumn>
          <Col allPr={0}>
            <div {...bemClasses('text', 'h2')}>
              <h2 children={i18n('complexYoutubeTopic', { placeholder: typeTxt })} />
            </div>
          </Col>
        </Row>
        <div {...bemClasses('content')}>
          <Slick {...bemClasses('slider')}>
            {map(complex_youtube, (item, key) => {
              return (
                <div {...bemClasses('video')} key={key}>
                  <YoutubeIframe
                    className={bemClasses}
                    videoId={item}
                    otherProps={{
                      toContentWithoutBtn: true
                    }}
                  />
                </div>
              )
            })}
          </Slick>
        </div>
      </div>
    </LazyHydrate>
  );
}

function renderForumLink() {
  const { project = {} } = this.props;
  const complex_forums = get(project, 'advanced_info.complex_forums.val');
  const label = get(project, 'advanced_info.complex_forums.label');

  if (!complex_forums || !label) return null;

  return (
    <div
      {...bemClasses('item', { forum: true, row: true })}
    >
      <span {...bemClasses('text', 'icon')}>
        <Icon {...bemClasses('icon')} type={iconTypes.commentInvert} />
      </span>
      <span {...bemClasses('text', 'colRight')}>
        <Counter
          mode="click"
          injectClickName="onClick"
          entity={{
            project_id: project.id,
            url_forum: complex_forums
          }}
          action="forumClick"
        >
          <Link
            {...bemClasses('link')}
            href={complex_forums}
            title={label}
            noRedirector
            external
          >
            <span {...bemClasses('linkContent')}>
              <span {...bemClasses('text')} children={label} />
            </span>
          </Link>
        </Counter>
      </span>
    </div>
  );
}

export function renderOverflights(overflightsArray, slicedNumber, topic) {
  if (checkIsEmpty(overflightsArray)) return null;

  const { i18n } = this;
  const lang = get(this, 'context.lang');
  const sortByDate = sortBy(overflightsArray, item => item.overflight_date).reverse();
  const slicedArr = sortByDate.slice(0, slicedNumber);
  const breakpointTablet = (this.sensor.getVariable('breakpointTablet') || 768) - 1;
  const topicH2 = topic ? ` ${topic}` : '';

  return (
    <div {...bemClasses('blockOverflights')}>
      <Row {...bemClasses('rowTopic')}>
        <Col allPr={0}><div {...bemClasses('text', 'h2')}><h2 children={`${i18n('overflight')}${topicH2}`} /></div></Col>
      </Row>
      <div {...bemClasses('content')}>
        <Slick
          slidesToShow={2}
          slidesToScroll={1}
          responsive={[
            {
              breakpoint: breakpointTablet,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]}
          dots={true}
        >
          {map(slicedArr, (item, key) => {
            const date = getOnlyMonthAndYear(item.overflight_date, lang);
            const link = get(item, 'overflight_link');

            return (
              <div {...bemClasses('video')} key={key}>
                <YoutubeIframe
                  className={bemClasses}
                  videoId={link}
                  otherProps={{
                    toContentWithoutBtn: true
                  }}
                />
                <div {...bemClasses('text')} children={date} />
              </div>
            );
          })}
        </Slick>
      </div>
    </div>
  );
}
